var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-right-table-2"},[_c('dv-border-box-6',[_c('div',{staticClass:"table-name"},[_c('img',{attrs:{"src":require("./img/icon2.png")}}),_vm._v("SMT料站信息\n    ")]),_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }